<div class="w-75 my-3 ms-3">
	<app-note-list [view]="'tab'" [tableName]="TableName.RESERVATION" [tableId]="resourceID()"></app-note-list>
</div>
<app-tasks-list [tableId]="resourceID()" [tableName]="TableName.RESERVATION" [view]="'tab'"></app-tasks-list>
